<template>
  <div class="error404" style="margin-bottom:150px;">
    <img style="max-width:100%; margin-top:-50px; -webkit-user-select: none;margin: auto;background-color: hsl(0, 0%, 90%);transition: background-color 300ms; mix-blend-mode: screen; margin:auto;" src="https://mir-s3-cdn-cf.behance.net/project_modules/disp/9c7a2773609829.5c0f6e269e920.gif">
    <h2 style="font-size:42px;">Thank you!</h2>
    <h3>We will get back to you as soon as possible!</h3>
  </div>
</template>

<script>
export default {
  title: 'Patronus Records - Thank you!'
}
</script>

<style scoped>
  .error404 {
    padding-top:120px;
    widows: 100%;
    height: 100%;
    text-align: center;
    text-shadow: 0 8px 10px rgba(0, 0, 0, 0.5);
  }
  h1 {font-size: 122px;}
  h2 {font-size: 72px;}
  h3 {text-transform: uppercase; letter-spacing: 1px;}
</style>



// WEBPACK FOOTER //
// src/pages/thankyou.vue